import { configureStore, combineReducers, Tuple, Middleware, Action } from '@reduxjs/toolkit'
import itemReducer from '../Redux/Admin_Tasks/MDSSlice'
import { registerFormAPI } from './Register/registerSlice'
import logger from 'redux-logger'
import { signinFormAPI } from './SignIn/signinSlice'

const rootReducer = combineReducers({
    [registerFormAPI.reducerPath]: registerFormAPI.reducer,
    [signinFormAPI.reducerPath]: signinFormAPI.reducer,
    items: itemReducer,
})

export type RootState = ReturnType<typeof rootReducer>

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware()
            // prepend and concat calls can be chained
            .concat(logger),
})
export type AppDispatch = typeof store.dispatch
export type AppState = ReturnType<typeof store.getState>
export default store
